// FNP-973 — labels and basePath every navigate/link in the module references,
// so a route rename is one edit rather than a grep.
export default {
    entityKey: 'hosted-zones',
    basePath: '/hosted-zones',
    titles: {
        singular: 'Hosted Zone',
        plural: 'Hosted Zones',
    },
};
